import React, { useContext } from "react";
import { Snackbar, Alert, Slide, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MyContext from "../../Uttis/MyContext";

// Custom slide animation
function SlideDownTransition(props) {
  return <Slide {...props} direction="down" />;
}

const Success = () => {
  const { snack, message, setSnack } = useContext(MyContext);

  // Determine alert type based on message content
  const successKeywords = ["Thanks", "Success", "Added", "Subscribed", "Updated"];
  const warningKeywords = ["Warning", "Caution", "Note"];
  const errorKeywords = ["Error", "Failed", "Invalid", "Rejected"];

  let severity = "info"; // Default
  if (successKeywords.some(word => message?.includes(word))) severity = "success";
  else if (warningKeywords.some(word => message?.includes(word))) severity = "warning";
  else if (errorKeywords.some(word => message?.includes(word))) severity = "error";

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnack(false);
  };

  return (
    <Snackbar
      open={snack}
      autoHideDuration={3500}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      TransitionComponent={SlideDownTransition}
    >
      <Alert
        severity={severity}
        variant="filled"
        onClose={handleClose}
        sx={{
          width: "100%",
          fontSize: "15px",
          fontWeight: 500,
          borderRadius: "8px",
          boxShadow: "0 3px 10px rgba(0,0,0,0.15)",
        }}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        {message || "Operation completed successfully!"}
      </Alert>
    </Snackbar>
  );
};

export default Success;
